export class GalleryView {
  constructor(_base) {
    this.base = _base;
  }

  render(_images) {
    return `
    <input id="gallery-input" type="file" onchange="${this.base}.gallery.upload(this)"  accept=".jpg,.jpeg,.png,.webp"/>
    <div id="gallery" class="gallery" data="${JSON.stringify(_images)}" open="${_images.length > 0 ? _images[0] : ''}">
      <div id="gallery-loading" class="gallery-loading">
        <div class="window">
          <div class="text" id="gallery-loading-text"></div>
          <div class="loader"></div>
        </div>
      </div>
      <div class="visor" id="gallery-visor" style="${_images.length > 0 ? this.getBackground(_images[0], false) : ''}">
        <button id="gallery-btn-new" class="btn-2 ico-plus" onclick="${this.base}.gallery.add()">
          <span class="material-symbols-sharp">add</span>
          Agregar 
        </button>
        <button id="gallery-btn-change" class="btn-2 ico-plus" onclick="${this.base}.gallery.change()">
          <span class="material-symbols-sharp">refresh</span>
          Reemplazar 
        </button>
        <button id="gallery-btn-delete" class="btn-2 ico-plus" onclick="${this.base}.gallery.delete()" style="${_images.length == 0 ? 'display:none' : ''}">
          <span class="material-symbols-sharp">delete</span>
          Eliminar
        </button>
      </div>
      <div class="thumbs" id="gallery-thumbs">
      ${this.renderThumbs(_images)}
      </div>
    </div>
  `;
  }

  renderThumbs(_images) {
    let html = '';
    for (let i = 0; i < _images.length; i++) {
      html += `<div class="image" style="${this.getBackground(_images[i], true)}" onclick="${this.base}.gallery.showImage('${_images[i]}')"></div> `;
    }
    html += `
      <button class="btn-2 ico-plus" onclick="${this.base}.gallery.add()">
        <span class="material-symbols-sharp">add</span>
      </button>`;
    return html;
  }

  getBackground(_idcod, _isThumb) {
    return `background-image: url(${APICRUD.Image.GetUrl(_idcod, _isThumb)}), url(/assets/img/servicios.webp) !important`;
  }
}
